import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-x4 text-center" }
const _hoisted_2 = { class: "flex flex-col md:flex-row justify-center gap-x4 md:gap-x6" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "list-reset" }

import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import useProductClickAndCollect from '@/shared/product/purchase/ui/useProductClickAndCollect';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPurchaseClickAndCollectStoreInfo',
  setup(__props) {

const { clickAndCollectStoreInfo, showStoreInfo, closeStoreInfo } = useProductClickAndCollect();
const labels = useBlockLabels();

const dayStatus = (day) => {
    return day.isClosed ? labels.clickAndCollectStoreClosed : day.formattedTime;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    "is-open": _unref(showStoreInfo),
    class: "p-24 mx-auto bg-white flex flex-col fixed inset-0 sm:relative sm:inset-auto z-1 w-screen overflow-hidden md:h-auto md:w-screen-80 md:max-h-screen-70 md:max-w-850",
    onClose: _unref(closeStoreInfo)
  }, {
    default: _withCtx(() => [
      (_unref(clickAndCollectStoreInfo))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(clickAndCollectStoreInfo).name), 1),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, [
                (_unref(clickAndCollectStoreInfo).street)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(clickAndCollectStoreInfo).street), 1))
                  : _createCommentVNode("", true),
                (_unref(clickAndCollectStoreInfo).zipCode || _unref(clickAndCollectStoreInfo).city)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      (_unref(clickAndCollectStoreInfo).zipCode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(clickAndCollectStoreInfo).zipCode), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode("  "),
                      (_unref(clickAndCollectStoreInfo).city)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(clickAndCollectStoreInfo).city), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_unref(clickAndCollectStoreInfo).phone)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(clickAndCollectStoreInfo).phone), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(labels).clickAndCollectStoreOpeningHours), 1),
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clickAndCollectStoreInfo).openingHours.slice(0, 7), (day) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: day.formattedDate + day.formattedTime,
                      class: "grid grid-flow-col gap-40 mt-20"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(day.formattedDay), 1),
                      _createElementVNode("span", null, _toDisplayString(day.formattedDate), 1),
                      _createElementVNode("span", null, _toDisplayString(dayStatus(day)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["is-open", "onClose"]))
}
}

})